<template>
  <div class="modal-card">
    <header class="modal-card-head">
      <p class="modal-card-title">
        {{ title }}
      </p>
      <button type="button" class="delete" @click="$emit('close')" />
    </header>
    <section class="modal-card-body">
      <apexchart type="donut" :options="chartOptions" :series="series" />
      <div class="columns is-centered">
        <div class="column is-6">
          <b-table :data="data" :columns="columns" striped narrowed hoverable />
        </div>
      </div>
    </section>
  </div>
</template>
<script>

export default {
  name: 'DailyCalledGraphModal',
  props: {
    title: {
      type: String,
      default: '',
    },
    params: {
      type: Object,
      default: () => {
      },
    },
    states: {
      type: Object,
      default: () => {
      },
    },
  },
  data() {
    return {
      data: [],
      columns: [
        {
          field: 'state',
          label: '状態',
        },
        {
          field: 'value',
          label: '件数',
          width: '40',
          numeric: true
        }
      ],

      series: [],
      chartOptions: {
        labels: [],
        colors: ['#2E93fA', '#66DA26', '#546E7A', '#E91E63', '#FF9800'],
        chart: {
          type: 'donut',
        },
        responsive: [{
          breakpoint: 480,
          options: {
            chart: {
              width: 200
            },
            legend: {
              position: 'bottom'
            }
          }
        }]
      },
    }
  },
  created() {
    const series = []
    const labels = []
    const labelColors = []
    // TODO 順番依存
    const colors = [
      '#ff4b00',
      '#fff100',
      '#03af7a',
      '#005aff',
      '#4dc4ff',
      '#ff8082',
      '#f6aa00',
      '#990099',
      '#804000',
      '#ffcabf',
      '#ffff80',
      '#d8f255',
      '#bfe4ff',
      '#ffca80',
      '#77d9a8',
      '#c9ace6',
      '#ffffff',
      '#c8c8cb',
      '#84919e',
      '#000000',
    ]
    const allLabelColors = {...this.states}
    for (const [key] of Object.entries(this.states)) {
      allLabelColors[key] = colors.shift()
    }
    let total = 0
    for (const [key, value] of Object.entries(this.params)) {
      total += value
      series.push(value)
      labels.push(this.states[key])
      labelColors.push(allLabelColors[key])
      this.data.push({
        state: this.states[key],
        value: value,
      })
    }
    this.data.push({
      state: '合計',
      value: total,
    })

    this.series = series
    this.chartOptions.labels = labels
    this.chartOptions.colors = labelColors
  }
}
</script>

<style scoped>

</style>